export function removeClassNameById(id, className) {
  if (!id || isEmpty(className)) {
    return
  }

  let dom = document.getElementById(id)
  if (!dom) {
    return
  }

  const newClassName = dom.className.replace(className, "")
  dom.className = newClassName
}


export function addClassNameById(id, className) {
  if (!id || isEmpty(className)) {
    return
  }

  let dom = document.getElementById(id)
  if (!dom) {
    return
  }

  const newClassName = dom.className.replace(className, "") + " " + className
  dom.className = newClassName
}


function isEmpty(str) {
  if (str === undefined || str === null || str === '') {
    return true
  }

  if (str.match(/^[ ]*$/)) {
    return true
  }

  return false
}